module.exports = __webpack_public_path__ + "img/megapixel.ebb6e6f9.jpg";